import { ComponentProps, forwardRef } from "react";
import { twMerge } from "tailwind-merge";

export const Input = forwardRef<
  HTMLInputElement,
  ComponentProps<"input"> & { isError?: boolean }
>(({ className, isError, ...props }, ref) => (
  <input
    ref={ref}
    {...props}
    className={twMerge(
      "block w-full rounded-md border-0 py-1.5 text-sm leading-6 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-sky-700",
      isError &&
        "text-red-900 ring-red-300 placeholder:text-red-300 focus:ring-red-500",
      className
    )}
  />
));

Input.displayName = "Input";

export const IconInput = forwardRef<
  HTMLInputElement,
  ComponentProps<"input"> & {
    isError?: boolean;
    leadingIcon?: React.ReactNode;
    trailingIcon?: React.ReactNode;
    // At least one of icons is required
  } & ({ leadingIcon: React.ReactNode } | { trailingIcon: React.ReactNode })
>(({ className, leadingIcon, trailingIcon, isError, ...props }, ref) => (
  <div className="relative rounded-md shadow-sm">
    {leadingIcon && (
      <div className="absolute inset-y-0 left-0 flex items-center pl-3">
        {leadingIcon}
      </div>
    )}
    <input
      ref={ref}
      {...props}
      className={twMerge(
        "block w-full rounded-md border-0 py-1.5 text-sm leading-6 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-sky-700 disabled:bg-gray-50 disabled:text-gray-500 disabled:ring-gray-200",
        !!leadingIcon && "pl-10",
        !!trailingIcon && "pr-10",
        isError &&
          "text-red-900 ring-red-300 placeholder:text-red-300 focus:ring-red-500",
        className
      )}
    />
    {trailingIcon && (
      <div className="absolute inset-y-0 right-0 flex items-center pr-3">
        {trailingIcon}
      </div>
    )}
  </div>
));

IconInput.displayName = "IconInput";
